export default {
  apiUrl: process.env.HS_APIURI,
  authUrl: process.env.HS_AUTHURI,
  targetUrl: process.env.HS_TARGETURL,
  loginStatus: process.env.HS_LOGINSTATUS,
  titlePrefix: process.env.HS_TITLE_PREFIX || "Lennox - Public Wifi -",
  sentryDSN: process.env.SENTRY_DSN || "",
};
